exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-reportManagement-ResultBreakPointsModal-modal .src-components-reportManagement-ResultBreakPointsModal-body{height:250px}", ""]);

// exports
exports.locals = {
	"modal": "src-components-reportManagement-ResultBreakPointsModal-modal",
	"body": "src-components-reportManagement-ResultBreakPointsModal-body"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportManagement/ResultBreakPointsModal/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportManagement/ResultBreakPointsModal/styles.scss
// module chunks = 1